import { render, staticRenderFns } from "./FatFemale.vue?vue&type=template&id=67b962de&scoped=true&"
import script from "./FatFemale.vue?vue&type=script&lang=js&"
export * from "./FatFemale.vue?vue&type=script&lang=js&"
import style0 from "./FatFemale.vue?vue&type=style&index=0&id=67b962de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b962de",
  null
  
)

export default component.exports